module.exports = __webpack_public_path__ + "img/logo-medium.587d1523.png";